import React, { useState, useEffect, useRef, useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { btnP, btnSec } from "../../constants/styles";

function SignaturePad({ onSave, onCancel, h }) {
  const { t } = useContext(Ctx);
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
  }, []);

  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
    const y = (e.clientY || (e.touches && e.touches[0].clientY)) - rect.top;
    return { x, y };
  };

  const startDraw = (e) => {
    setIsDrawing(true);
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    if (e.cancelable) e.preventDefault(); // prevent scrolling
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.stroke();
  };

  const stopDraw = () => setIsDrawing(false);

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  const save = () => {
    const dataUrl = canvasRef.current.toDataURL("image/png");
    onSave(dataUrl);
  };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.8)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: h.bg, padding: 20, borderRadius: 16, width: "100%", maxWidth: 400 }}>
        <h3 style={{ color: h.tx, margin: "0 0 10px", fontSize: 16 }}>{t.drawSig}</h3>
        <p style={{ color: h.sc, fontSize: 12, marginBottom: 16 }}>{t.signBelow}</p>
        <div style={{ border: `2px dashed ${h.bd}`, borderRadius: 8, background: "#fff", marginBottom: 16, overflow: "hidden" }}>
          <canvas
            ref={canvasRef}
            style={{ width: "100%", height: 200, cursor: "crosshair", touchAction: "none" }}
            onMouseDown={startDraw}
            onMouseMove={draw}
            onMouseUp={stopDraw}
            onMouseLeave={stopDraw}
            onTouchStart={startDraw}
            onTouchMove={draw}
            onTouchEnd={stopDraw}
          />
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={clear} style={{ ...btnSec(h), flex: 1, marginTop: 0 }}>{t.clear}</button>
          <button onClick={onCancel} style={{ ...btnSec(h), flex: 1, marginTop: 0 }}>{t.cancel}</button>
          <button onClick={save} style={{ ...btnP(h), flex: 2, marginTop: 0 }}>{t.save}</button>
        </div>
      </div>
    </div>
  );
}

export default SignaturePad;
